module.exports = __webpack_public_path__ + "img/style_model_preview_680.983fdd3d.jpg";